export default "__VITE_ASSET__a0c0414d__"